import React, {useEffect} from 'react';
import {Separator, Icon, Icons, Flex, Popup, Button, Today, Activities, Layout, Video, DateNavigator, DateContext} from 'components';
import {modal, map, useNamedSelector, printSidebar, config, openPopup, useDragStart, useDrop, overEvery, redirect} from 'helpers';
import {update} from 'store/sorting';
import {navigate} from 'store/calendar';
import {forbid} from 'store/session';
import css from './sidebar.module.scss';

export function Sidebar() {
  let heading = '';
  const {currentDate, fullscreen} = useNamedSelector('calendar.settings');
  const list = useNamedSelector('calendar.list', {
    date: currentDate,
    module: 'Today',
    filter: overEvery(
      useNamedSelector('settings.shareStatusFilter', {context: 'activities'}),
      useNamedSelector('activities.externalCalendarsFilter')
    )
  });

  useEffect(() => {
    window.document.body.classList.toggle('is-fullscreen', Boolean(fullscreen));
    return () => window.document.body.classList.remove('is-fullscreen');
  }, [ fullscreen ]);

  const onDrop = useDrop((event, grabbed) => {
    update({
      all: map(list, 'id').filter(Boolean),
      container: event.currentTarget,
      grabbed,
      name: 'Today'
    });
  }, grabbed => grabbed.type === 'activity');

  return !fullscreen && (
    <Layout.Sidebar {...onDrop}>
      <Flex className={['justified']}>
        <div>
          <h3>{ currentDate.calendar(null, { thisYear: 'dddd', sameElse: 'dddd' }) }</h3>
          <DateNavigator value={currentDate} setValue={navigate} className="small-spacing" />
        </div>
        <Flex middle className={css('icons', 'secondary', 'hidden-print')}>
          <Icons.Print onClick={printSidebar} />
          <Video.Trigger src={config.videos.today} />
          <Today.SidebarPreferences />
          <Icon name="plus-large" onClick={openPopup(CreateActivityMenu, {currentDate})} aria-haspopup />
        </Flex>
      </Flex>
      <Layout.Sidebar.Scrollable>
        <DateContext.Provider value={currentDate}>
          { list.map(activity => activity.heading !== undefined
            ? <Separator key={heading=activity.heading} heading={activity.heading} icon={activity.heading} />
            : <Activities.Card
                Checkbox={Activities.Checkbox}
                id={activity.id}
                key={heading+activity.id}
                {...activity}
                {...useDragStart(activity.status === 'Not Started' && {
                  contextDate: currentDate,
                  id: activity.id,
                  occurance: activity.occurance,
                  // on: activity.status == 'Not Started' && !action,
                  type: 'activity'
                })}
              />
          ) }
        </DateContext.Provider>
        { list.length == 0 &&
          <p className="text-center">
            <Button icon="plus" className={['stretch', 'primary']} onClick={openPopup(CreateActivityMenu, {currentDate})} aria-haspopup>
              Add Activity
            </Button>
          </p>
        }
      </Layout.Sidebar.Scrollable>
    </Layout.Sidebar>
  );
}

function CreateActivityMenu({currentDate, popup}) {
  const {canAdd} = useNamedSelector('permissions.list');
  return (
    <Popup.Menu>
      <Popup.Menu.Item icon="calendar" onClick={canAdd.activities ? modal(Activities.Single.EditForm, { date: currentDate }) : forbid}>
        Add Activity
      </Popup.Menu.Item>
      { config.sw &&
        <Popup.Menu.Item icon="block_time" onClick={canAdd.activities ? modal(Activities.Single.EditForm, { date: currentDate, isBlockType: true }) : forbid}>
          Block Time
        </Popup.Menu.Item>
      }
      {/*<Popup.Menu.Item icon="play-alt" onClick={modal(Today.StopwatchTimer)}>*/}
      {/*  Focus*/}
      {/*</Popup.Menu.Item>*/}
      <Popup.Menu.Item icon="recurring" onClick={canAdd.recurring ? modal(Activities.Single.EditForm, { defaultType: 'routine' }) : forbid}>
        Schedule Routine
      </Popup.Menu.Item>
      <Popup.Menu.Item icon={{ name: 'calendar', Sub: Icons.RecurringSmall }} onClick={canAdd.recurring ? modal(Activities.Single.EditForm, { defaultType: 'routine', dailyRoutineType: 'daily_routine' }) : forbid}>
        Add Daily Ritual
      </Popup.Menu.Item>
      <Popup.Menu.Item icon="clipboard" onClick={canAdd.goals ? () => redirect(`/today/plan-my-week/start`, true) : forbid}>
        Plan My Week
      </Popup.Menu.Item>
    </Popup.Menu>
  );
}
